import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_StylesForMolType = _resolveComponent("StylesForMolType");
    const _component_Section = _resolveComponent("Section");
    return (_openBlock(), _createBlock(_component_Section, { title: "" }, {
        default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stylesForMolTypes, (styleForMolType) => {
                return (_openBlock(), _createElementBlock("span", {
                    key: styleForMolType.molType
                }, [
                    _createVNode(_component_StylesForMolType, {
                        style: _normalizeStyle(styleForMolType.style),
                        molType: styleForMolType.molType
                    }, null, 8, ["style", "molType"])
                ]));
            }), 128))
        ]),
        _: 1
    }));
}
